<div class="app-layout">
    <!-- Mobile Sidebar Overlay -->
    <div class="sidebar-overlay" [class.show]="!isSidebarCollapsed()" (click)="toggleSidebar()"></div>
    
    <!-- Sidebar spans full height -->
    <ms-side-navigation [(isSidebarCollapsed)]="isSidebarCollapsed">
    </ms-side-navigation>
    
    <!-- Main content area -->
    <div class="main-layout" [class.sidebar-collapsed]="isSidebarCollapsed()">
        <!-- Top Navbar -->        
        <ms-header [(isSidebarCollapsed)]="isSidebarCollapsed"></ms-header>

        <!-- Main Content Wrapper -->
        <!-- pt-4 matches the 1.5rem gutter the page cards set themselves with mx-4/mb-4. -->
        <div class="main-content-wrapper m-0 pt-4">
            <router-outlet />
        </div>

        <!-- Footer -->
        <ms-footer></ms-footer>
    </div>
</div>
